module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/067-kenya-872d4159d767e1aeb05648f3079d6fe5.svg";